<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Emergência no Destino?</p>
      </header>
      <section class="modal-card-body">
        <div>
          <img id="support" src="~assets/contact3.png" alt="Suporte">
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control">
            <a :class="{'button': true, 'is-success': true}" @click="close()">Close</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      }
    },
    data () {
      return {
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    },
    methods: {
      close (closeOnly, result) {
        this.context.$store.dispatch('SET_ALERT', false)
        this.$el.remove()
      }
    },
    components: {
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// Alert.vue?2d4eba7c